import { Button, ButtonProps } from "@mantine/core"
import { forwardRef } from "react"

interface BlueButtonProps extends ButtonProps {
  onClick?: () => void
  type?: "submit" | "button"
  component?: any
  href?: string
  download?: string
  hidden?: boolean
}

/**
 * @deprecated - Just use a normal button
 */
export const BlueButton = forwardRef<HTMLButtonElement, BlueButtonProps>(function BlueButton({ children, onClick, type, download, hidden, ...props }, ref) {
  return (
    <Button
      ref={ref}
      size="sm"
      radius="sm"
      variant="filled"
      {...props}
      // darkHidden
      onClick={onClick}
      type={type}
      color="rBackBlue.9"
      download={download}
      hidden={hidden}
    >
      {children}
    </Button>
  )
})
